/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Supportcontactdescription2Inputs */

const en_settings_supportcontactdescription2 = /** @type {(inputs: Settings_Supportcontactdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For more questions, please contact`)
};

/**
* | output |
* | --- |
* | "For more questions, please contact" |
*
* @param {Settings_Supportcontactdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_supportcontactdescription2 = /** @type {((inputs?: Settings_Supportcontactdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Supportcontactdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_supportcontactdescription2(inputs)
});
export { settings_supportcontactdescription2 as "settings_supportContactDescription" }